export const ZRM_DEV_BRAND = 'dev_brand';
export const HOST_APP = 'hostApp';
export const ZRM_API = 'ZRM_API';

export const ZRM_RENT_GUARANTEE_ENABLED = 'ZRM_RENT_GUARANTEE_ENABLED';
export const ZRM_USE_FREEMIUM_TEST_DATA = 'ZRM_USE_FREEMIUM_TEST_DATA';
export const ZRM_ONBOARDING_WIZARD_ENABLED = 'ZRM_ONBOARDING_WIZARD_ENABLED';
export const ZRM_USER_ONBOARDING_ENABLED = 'ZRM_USER_ONBOARDING_ENABLED';
export const ZRM_USE_UPLIFT_BRAIN_TEST_DATA = 'ZRM_USE_UPLIFT_BRAIN_TEST_DATA';
export const ZRM_MARKETING_COMPONENTS_ENABLED = 'ZRM_MARKETING_COMPONENTS_ENABLED';
export const ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED = 'ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED';
export const ZRM_TOTAL_MONTHLY_PRICE_ENABLED = 'ZRM_TOTAL_MONTHLY_PRICE_ENABLED';
export const ZRM_AUTH_0_MFA_ENABLED = 'ZRM_AUTH_0_MFA_ENABLED';
export const ZRM_MULTIPLEX_LISTING_FLOW_ENABLED = 'ZRM_MULTIPLEX_LISTING_FLOW_ENABLED';
export const ZRM_USER_MANAGEMENT_ENABLED = 'ZRM_USER_MANAGEMENT_ENABLED';
// Keep this literal in sync with ZRM_IA_NAV_ENABLED in
// @zg-rentals/zrm-header-navigation (src/utils/featureFlags.ts), which reads this cookie.
export const ZRM_IA_NAV_ENABLED = 'ZRM_IA_NAV_ENABLED';
export const ZRM_PORTFOLIO_DASHBOARD_ENABLED = 'ZRM_PORTFOLIO_DASHBOARD_ENABLED';

export const ZRM_FLEXIBLE_PROPERTIES_ENABLED = 'ZRM_FLEXIBLE_PROPERTIES_ENABLED';

export const ZRM_LISTING_LIST_ENABLED = 'ZRM_LISTING_LIST_ENABLED';

export const ZRM_FEATURE_TOUR_ENABLED = 'ZRM_FEATURE_TOUR_ENABLED';

export const ZRM_AI_LISTING_CREATION_TEST_B_ENABLED = 'ZRM_AI_LISTING_CREATION_TEST_B_ENABLED';
export const ZRM_OWNERSHIP_VERIFICATION_ENABLED = 'ZRM_OWNERSHIP_VERIFICATION_ENABLED';
export const ZRM_AUTO_SPOTLIGHT_UI_ENABLED = 'ZRM_AUTO_SPOTLIGHT_UI_ENABLED';
// Gates the Smart Assign controls on their own, so they stay dark for pilot customers already on the panel.
export const ZRM_SMART_ASSIGN_UI_ENABLED = 'ZRM_SMART_ASSIGN_UI_ENABLED';
export const ZRM_FEED_OVERRIDES_ENABLED = 'ZRM_FEED_OVERRIDES_ENABLED';
export const ZRM_ADD_STREETEASY_PROPERTY_ENABLED = 'ZRM_ADD_STREETEASY_PROPERTY_ENABLED';
export const ZRM_AUTO_SPOTLIGHT_UI_ALLOWLIST_EMAILS = ['ghiggins@resicap.com', 'lumlauf@resicap.com'];
// Grants Smart Assign UI access by email without the ZRM_SMART_ASSIGN_UI_ENABLED cookie (mirrors the auto-spotlight allowlist).
export const ZRM_SMART_ASSIGN_UI_ALLOWLIST_EMAILS: Array<string> = [];

export const ZRM_SHOW_CANCELLED_TOURS = 'ZRM_SHOW_CANCELLED_TOURS';

export const ZG_COMP_INSIGHTS = 'ZG_COMP_INSIGHTS';

export const ZRM_REACT_QUERY_DEVTOOLS = 'ZRM_REACT_QUERY_DEVTOOLS';
export const ZRM_DEVTOOLS_ENABLED = 'ZRM_DEVTOOLS_ENABLED';

export const ZRM_MOCK_USER_ENABLED = 'ZRM_MOCK_USER_ENABLED';
export const ZRM_MOCK_USER_EMAIL = 'ZRM_MOCK_USER_EMAIL';
export const ZRM_MOCK_USER_IMPERSONATOR_TOKEN = 'ZRM_MOCK_USER_IMPERSONATOR_TOKEN';
export const ZRM_MOCK_USER_IMPERSONATOR_EMAIL = 'ZRM_MOCK_USER_IMPERSONATOR_EMAIL';

export const ZRM_MOCK_USERS_GENERATE_NEW_EMAIL = 'xxxxxxxxxx@zillow.com';

export const ZRM_MOCK_USERS = [
  {
    email: ZRM_MOCK_USERS_GENERATE_NEW_EMAIL,
    comment: 'Generate a new user',
  },
  {
    email: 'mockeduser@zillow.com',
    comment: 'Default mock user',
  },
  {
    email: 'rocket_ship_user@zillow.com',
    comment: 'Single family feed listings',
  },
  {
    email: 'mfh_rocket_ship_user@zillow.com',
    comment: 'Multifamily feed listings',
  },
  {
    email: 'mfh_user@zillow.com',
    comment: 'Multifamily customer',
  },
  {
    email: 'company_admin@zillow.com',
    comment: 'Company admin for user management',
  },
  {
    email: 'nucleus_user@zillow.com',
    comment: 'Single family paid inclusion',
  },
  {
    email: 'single_family_legacy@zillow.com',
    comment: 'Old single family legacy user',
  },
  {
    email: 'flat_fee_rocket_ship_user@zillow.com',
    comment: 'Single family with flat fee product',
  },
  {
    email: 'rentalrevenueplatform@zillow.com',
    comment: 'To test multifamily packages',
  },
  {
    email: 'streeteasy_user@streeteasy.com',
    comment: 'StreetEasy user',
  },
];
